import { render, staticRenderFns } from "./how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv.vue?vue&type=template&id=27458386&scoped=true&"
import script from "./how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv.vue?vue&type=script&lang=js&"
export * from "./how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv.vue?vue&type=script&lang=js&"
import style0 from "./how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv.vue?vue&type=style&index=0&id=27458386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27458386",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VCard,VCardSubtitle,VCardText,VCardTitle,VCol,VImg,VStepper,VStepperContent,VStepperStep,VTab,VTabItem,VTabs,VTabsItems})
